import React, { ReactNode } from 'react';

import {
  Buttons,
  ButtonsLeft,
  ButtonsRight,
  Content,
  ErrorMessage,
  Footer,
  Main,
  Page,
} from './styles';
import { FlowModalContentType } from '../types';

export interface FlowModalContentProps {
  children: ReactNode;
  error?: string | null;
  buttons?: ReactNode[];
  buttonsLeft?: ReactNode[];
  contentType?: FlowModalContentType;
}

export const FlowModalContent = React.memo(
  ({
    children,
    error,
    buttons,
    buttonsLeft,
    contentType = FlowModalContentType.FixedWidth,
  }: FlowModalContentProps) => {
    return (
      <>
        <Page>
          <Main>
            <Content {...{ contentType }}>{children}</Content>
          </Main>
        </Page>
        {(buttons || buttonsLeft) && (
          <Footer>
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <Buttons>
              <ButtonsRight>{buttons}</ButtonsRight>
              {buttonsLeft && <ButtonsLeft>{buttonsLeft}</ButtonsLeft>}
            </Buttons>
          </Footer>
        )}
      </>
    );
  }
);
